import { render } from "./UserLink.vue?vue&type=template&id=223766cb&scoped=true"
const script = {}

import "./UserLink.vue?vue&type=style&index=0&id=223766cb&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223766cb"]])

export default __exports__